import qs from "qs"
import client from "../client"

export const getMotibellMainList = async ({ status, currDate, offset }) => {
  const queryString = qs.stringify({
    curr_date: currDate,
    status,
    offset,
  })

  const response = await client.get(`/motibells/main/list?${queryString}`)

  return response.data
}
